<template>
  <div class="mini-user-page">
    <div class="center-content" @click.stop="handleClickMain">
      <div class="recommend-num-box">
        <i class="icondaniumoban iconfont"></i>
        <span>匹配到 5 位行业大牛</span>
      </div>
      <div :class="['user-card-item', `item${index}`]" v-for="(item, index) in data.recommendUsers" :key="index + 'user'" @click.stop="handleClickUser(item)">
        <img  :src="item.avatar" width="35" height="35"/>
        <div class="message">
          <p class="user-name">{{item.profession_name && (item.profession_name)  || '超级简历用户'}}</p>
          <p class="user-post">{{item.company_nick_name || item.company_name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import api from "../../../api";

  export default {
    name: "mini-user",
    props: {
      user: {
        type: Array,
        default: () => []
      },
      typeName: String,
      data: {
        type: Object,
        default: () => ({
          recommendUsers: [],
          profession_name: ''
        })
      }
    },
    computed: {
      ...mapState('planning', ['resumeDetail'])
    },
    methods: {
      handleClickUser(user){
        api.planning.getExperience(user.cv_token).then(res=>{
          if(res.code === 1000){
            window.open(`/planning/report/${user.cv_token}?me_token=${this.$route.params.token}&profession_id=${this.data.profession_id}&user=${user.name.substr(0,1)}&profession_name=${this.data.profession_name}`,"_blank")
          }else {
            this.$message('无法生成对比报告')
          }
        })

      },
      handleClickMain(){
        window.open(`/planning/${this.data.profession_id}/detail?me_token=${this.$route.params.token}`,"_blank" )
      }
    }
  }
</script>

<style scoped lang="scss">
.mini-user-page{
  width: 515px;
  height: 282px;
  position: absolute;
  top: -56px;
  left: -156px;
  .center-content{
    width: 180px;
    height: 180px;
    position: absolute;
    top: 56px;
    left: 156px;

  }
  .recommend-num-box{
    width: 186px;
    height: 44px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 22px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    /*filter: blur(10px);*/
    position: absolute;
    top: -56px;
    left: -3px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    .iconfont{
      margin-right: 8px;
      font-size: 16px;
    }
  }
  .user-card-item{
    position: absolute;
    display: flex;
    width: 156px;
    height: 55px;
    background-image: url("https://files.wondercv.com/pc/planning/miniuser.png");
    background-size: 100%;
    background-repeat: no-repeat;
    border-radius: 28px;
    box-sizing: border-box;
    padding: 10px 11px;
    align-items: center;
    &:hover{
      background-image: url("https://files.wondercv.com/pc/planning/miniuserhover.png");
    }
    &>img{
      border-radius: 50%;
      margin-right: 8px;
      object-fit: cover;
      filter: blur(1px);
    }
    .message{
      flex: 1;
      overflow:hidden; //超出的文本隐藏
      .user-name{
        font-size: 15px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 21px;
        width: 100%;
        overflow:hidden; //超出的文本隐藏
        text-overflow:ellipsis; //溢出用省略号显示
        white-space:nowrap; //溢出不换行
      }
      .user-post{
        width: 100%;
        font-size: 13px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 18px;
        overflow:hidden; //超出的文本隐藏
        text-overflow:ellipsis; //溢出用省略号显示
        white-space:nowrap; //溢出不换行
        margin-right: 10px;
      }
    }
    &.item0{
      top: -6px;
      right: -156px;
    }
    &.item1{
      top: 94px;
      right: -179px;
    }
    &.item2{
      bottom: -57px;
      left: 125px;
    }
    &.item3{
      top: 143px;
      left: -134px;
    }
    &.item4{
      top: 12px;
      left: -156px;
    }

  }
}
</style>
